import { apiClient } from './client';

export const getDashboardConfig = () =>
  apiClient.get('/dashboard/config').then((r) => r.data);

export const saveDashboardConfig = (config) =>
  apiClient.post('/dashboard/config', config).then((r) => r.data);

export const touchActiveFileConfig = (activeFile) =>
  apiClient.patch('/dashboard/config/active-file', { active_file: activeFile }).then((r) => r.data);
